import { Row } from '../model'

export const changeOrderByPrev = <R extends Row>(
  allData: R[],
  moved: R[],
  prevUuid: string | undefined
): R[] => {
  // Create new references for moved rows so ag-grid detects them as updated
  // (required for getRowId/immutable data mode to re-evaluate sibling order)
  const movedWithNewRefs = moved.map(m => ({ ...m }))
  const movedUuids = new Set(moved.map(m => m.uuid))
  // Update row order.
  const result: R[] = []
  // If prevUuid is undefined, it means inserting first.
  if (!prevUuid) {
    result.push(...movedWithNewRefs)
  }
  for (let d of allData) {
    // Skip moved rows.
    if (movedUuids.has(d.uuid)) continue
    result.push(d)
    if (prevUuid && d.uuid === prevUuid) {
      result.push(...movedWithNewRefs)
    }
  }
  return result
}

export const changeOrderByFollowing = <R extends Row>(
  allData: R[],
  moved: R[],
  followingUuid: string | undefined
): R[] => {
  // Create new references for moved rows so ag-grid detects them as updated
  const movedWithNewRefs = moved.map(m => ({ ...m }))
  const movedUuids = new Set(moved.map(m => m.uuid))
  const result: R[] = []
  for (let d of allData) {
    // Skip moved rows.
    if (movedUuids.has(d.uuid)) continue
    if (followingUuid && d.uuid === followingUuid) {
      result.push(...movedWithNewRefs)
    }
    result.push(d)
  }
  // If prevUuid is undefined, it means inserting last.
  if (!followingUuid) {
    result.push(...movedWithNewRefs)
  }
  return result
}
